import { createDomain, createEvent } from 'effector';

export type BluetoothDevice = {
  address: string;
  name: string;
};

export type BtScanResultPayload = {
  mac: string;
  name: string;
}[]

const reset = createEvent();
const domain = createDomain();

const $devices = domain.createStore<BtScanResultPayload>([])

const setDevices = createEvent<BtScanResultPayload>();

$devices.on(setDevices, (_, payload) => payload);

domain.onCreateStore((store) => store.reset(reset));


export const bluetoothEntity = {
  $devices,
  setDevices,
  reset,
};

